import React from 'react';
import { NavLink } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import Badge from '@mui/material/Badge';
import { css } from '@emotion/react';

interface Props {
  path: string;
  listItemName: string;
  badgeCount?: number;
  showBadgeNumber?: boolean;
}

const Link = css`
  padding: 8px 16px 8px 40px;
  width: 100%;
  color: #000;
  text-decoration: none;
  display: flex;
  justify-content: space-between;

  &.active {
    font-weight: bold;
    color: var(--nav-active-text);
    background-color: var(--nav-active-bg);
  }
`;

export const LeftNavListItem = React.memo(({ path, listItemName, badgeCount, showBadgeNumber }: Props) => {
  return (
    <ListItem button disablePadding>
      <NavLink exact to={path} css={Link} activeClassName='active'>
        <div>{listItemName}</div>
        <div>
          {!!badgeCount &&
            (showBadgeNumber ? (
              <Badge color='error' variant='dot' />
            ) : (
              <Badge color='error' badgeContent={badgeCount} />
            ))}
        </div>
      </NavLink>
    </ListItem>
  );
});
